// Shared "Roster" section header + Spotify-style filter chips. Rendered at the top of the
// three Roster sub-screens (Players → /roster, Free Agents → /signings, Trades → /trade) so
// they read as one tabbed section: the chip row stays put and the panel below swaps. Each
// chip is a route, so the active panel's own worker data loads without merging views.

import { realtimeUpdate } from "../util/realtimeUpdate.ts";

type Key = "players" | "signings" | "trade";

const CHIPS: { key: Key; label: string; sub: string }[] = [
	{ key: "players", label: "My Team", sub: "/roster" },
	{ key: "signings", label: "Free Agents", sub: "/signings" },
	{ key: "trade", label: "Trades", sub: "/trade" },
];

export const RosterTabs = ({
	active,
	lid,
}: {
	active: Key;
	lid: number | undefined;
}) => (
	<>
		<style>{styles}</style>
		<h1 className="rtabs-title">Roster</h1>
		<div className="rtabs-row">
			{CHIPS.map((c) => (
				<button
					key={c.key}
					className={`rtabs-chip ${active === c.key ? "active" : ""}`}
					onClick={() => {
						if (active !== c.key && lid !== undefined) {
							realtimeUpdate([], `/l/${lid}${c.sub}`);
						}
					}}
				>
					{c.label}
				</button>
			))}
		</div>
	</>
);

const styles = `
.rtabs-title { font-weight:900; font-size:30px; letter-spacing:-.5px; margin:0; }
.rtabs-row { display:flex; gap:8px; overflow-x:auto; margin:14px 0 16px; padding-bottom:2px;
  scrollbar-width:none; -ms-overflow-style:none; }
.rtabs-row::-webkit-scrollbar { display:none; }
.rtabs-chip { flex:0 0 auto; border:none; border-radius:999px; padding:8px 16px; font-size:13px;
  font-weight:700; font-family:inherit; cursor:pointer; background:#232323; color:#cfe0ec;
  white-space:nowrap; transition:background .15s ease, color .15s ease; }
.rtabs-chip:hover { background:#2c2c2c; color:#fff; }
.rtabs-chip.active { background:#18E0A8; color:#0a0a0a; }
`;

export default RosterTabs;
